import './app.scss'
import './ie11.js'

//#region Gridster

import 'angular-gridster/dist/angular-gridster.min.css'

//#endregion

//#region JQuery

import 'jquery'

//#endregion

//#region Angular

import UI_ROUTER_MODULE_NAME, { StateProvider, UrlRouterProvider, StateService, StateDeclaration, TransitionService } from '@uirouter/angularjs'

import * as angular from 'angular'

import * as AGNULAR_COOKIES_MODULE_NAME from 'angular-cookies'
import * as AGNULAR_SANITIZE_MODULE_NAME from 'angular-sanitize'
import * as AGNULAR_FILTER_MODULE_NAME from 'angular-filter'
import * as AGNULAR_MATERIAL_ICONS_MODULE_NAME from 'angular-material-icons'
import 'angular-bowser'

const AGNULAR_BOWSER_MODULE_NAME = 'jlareau.bowser'

//#endregion

//#region Boostrap

import 'bootstrap';

//#endregion

//#region Slick

import 'slick-carousel'
import 'slick-carousel/slick/slick.scss'
import 'slick-carousel/slick/slick-theme.scss'
import 'angular-slick-carousel'

const AGNULAR_SLICK_CAROUSEL_MODULE_NAME = 'slickCarousel'

//#endregion

//#region DevExtreme

import 'devextreme/integration/jquery'
import 'devextreme/integration/angular'

import 'devextreme/localization/globalize/number'
import 'devextreme/localization/globalize/date'
import 'devextreme/localization/globalize/currency'
import 'devextreme/localization/globalize/message'

import * as deMessages from '../node_modules/devextreme/localization/messages/de.json'
import * as enMessages from '../node_modules/devextreme/localization/messages/en.json'
import * as esMessages from '../node_modules/devextreme/localization/messages/es.json'
import * as frMessages from '../node_modules/devextreme/localization/messages/fr.json'
import * as itMessages from '../node_modules/devextreme/localization/messages/it.json'
import * as ruMessages from '../node_modules/devextreme/localization/messages/ru.json'

import * as deCldrData from 'devextreme-cldr-data/de.json'
import * as enCldrData from 'devextreme-cldr-data/en.json'
import * as enGBCldrData from 'devextreme-cldr-data/en-GB.json'
import * as esCldrData from 'devextreme-cldr-data/es.json'
import * as frCldrData from 'devextreme-cldr-data/fr.json'
import * as itCldrData from 'devextreme-cldr-data/it.json'
import * as plCldrData from 'devextreme-cldr-data/pl.json'
import * as ruCldrData from 'devextreme-cldr-data/ru.json'
import * as srLatnCldrData from 'devextreme-cldr-data/sr-Latn.json'
import * as supplemental from 'devextreme-cldr-data/supplemental.json'

import * as Globalize from 'globalize'

const DEV_EXTREME_MODULE_NAME = 'dx'

//#endregion

//#region IMR Imports

import { SERVICES_MODULE_NAME as IMR_SERVICES_MODULE_NAME } from '@imr/controls.angularjs/services'
import { COMPONENT_MODULE_NAME as IMR_COMPONENT_MODULE_NAME } from '@imr/controls.angularjs/components'
import { MODULE_NAME as IMR_MXGRAPH_MODULE_NAME } from '@imr/controls.mxgraph.angularjs'

//#endregion

import { AppController } from './app.controller'


//#region Modules

import actionsModule from './modules/actions/actions.module'
import actorsModule from './modules/actors/actors.module'
import alarmGroupsModule from './modules/alarm-groups/alarm-groups.module'
import alarmsModule from './modules/alarms/alarms.module'
import cashierPanelModule from './modules/cashier-panel/cashier-panel.module'
import consumersModule from './modules/consumers/consumers.module'
import consumerTypesModule from './modules/consumer-types/consumer-types.module'
import dashboardModule from './modules/dashboard/dashboard.module'
import depositoriesModule from './modules/depositories/depositories.module'
import deviceConnectionsModule from './modules/deviceconnections/deviceconnections.module'
import devicesModule from './modules/devices/devices.module'
import distributorsModule from './modules/distributors/distributors.module'
import dxdashboardModule from './modules/dxdashboard/dxdashboard.module'
import groupingLocationsModule from './modules/grouping-locations/grouping-locations.module'
import groupingLocationsTypesModule from './modules/grouping-locations-types/grouping-locations-types.module'
import issuesModule from './modules/issues/issues.module'
import kpiModule from './modules/kpi/kpi.module'
import locationsModule from './modules/locations/locations.module'
import loginModule from './modules/login/login.module'
import metersModule from './modules/meters/meters.module'
import operatorGroupModule from './modules/operator-group/operator-group.module'
import operatorModule from './modules/operators/operators.module'
import ordersModule from './modules/orders/orders.module'
import packagesModule from './modules/packages/packages.module'
import reportsModule from './modules/reports/reports.module'
import routesModule from './modules/routes/routes.module'
import scriptsModule from './modules/scripts/scripts.module'
import settingsModule from './modules/settings/settings.module'
import simcardsModule from './modules/simcards/simcards.module'
import supplierModule from './modules/suppliers/suppliers.module'
import tariffsModule from './modules/tariffs/tariffs.module'
import tasksModule from './modules/tasks/tasks.module'
import tasksTypesModule from './modules/tasks-types/tasks-types.module'

//#endregion

import servicesModule from './services/services.module'

import { Enums } from './models/common'
import { Api, LocalDictionaryFactory } from './modules/api/api.module'
import { I18NProvider } from './modules/common/i18n/common.i18n.provider'
import { IUserSession, UserSession, ConfigHelper, LogHelper, DataProvider } from './helpers'

import { USER_SESSION_SERVICE_NAME } from './services/user-session'
import { $INTERVAL_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, $SCOPE_SERVICE_NAME, BOWSER_SERVICE_NAME, $ROOT_SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $WINDOW_SERVICE_NAME } from './services/system'

export var simax = angular.module('simax', [
    AGNULAR_SANITIZE_MODULE_NAME,
    AGNULAR_COOKIES_MODULE_NAME,
    AGNULAR_BOWSER_MODULE_NAME,
    AGNULAR_FILTER_MODULE_NAME,
    AGNULAR_MATERIAL_ICONS_MODULE_NAME,
    AGNULAR_SLICK_CAROUSEL_MODULE_NAME,

    UI_ROUTER_MODULE_NAME,
    DEV_EXTREME_MODULE_NAME,

    IMR_MXGRAPH_MODULE_NAME,
    IMR_SERVICES_MODULE_NAME,
    IMR_COMPONENT_MODULE_NAME,
    servicesModule,

    actionsModule,
    actorsModule,
    alarmGroupsModule,
    alarmsModule,
    cashierPanelModule,
    consumersModule,
    consumerTypesModule,
    dashboardModule,
    depositoriesModule,
    deviceConnectionsModule,
    devicesModule,
    distributorsModule,
    dxdashboardModule,
    groupingLocationsModule,
    groupingLocationsTypesModule,
    issuesModule,
    kpiModule,
    locationsModule,
    loginModule,
    metersModule,
    operatorGroupModule,
    operatorModule,
    ordersModule,
    packagesModule,
    reportsModule,
    routesModule,
    scriptsModule,
    settingsModule,
    simcardsModule,
    supplierModule,
    tariffsModule,
    tasksModule,
    tasksTypesModule
])

var resourcesDownloaded = false

simax.controller('appController', [
    $ROOT_SCOPE_SERVICE_NAME,
    $SCOPE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    $INTERVAL_SERVICE_NAME,
    $WINDOW_SERVICE_NAME,
    $Q_SERVICE_NAME,
    'i18n',
    '$state',
    '$transitions',
    'api',
    BOWSER_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    'localDictionary',
    (
        $rootScope: any,
        $scope: any,
        $timeout: ng.ITimeoutService,
        $interval: ng.IIntervalService,
        $window: ng.IWindowService,
        $q: ng.IQService,
        i18n,
        $state: StateService,
        $transition: TransitionService,
        api: Api,
        bowser: ng.bowser.IBowserService,
        userSession: IUserSession,
        localDictionary: LocalDictionaryFactory
    ) => {
        const app = new AppController($rootScope, $scope, $timeout, $interval, $window, $q, i18n, $state, $transition, api, bowser, userSession, localDictionary)

        new I18NProvider().setUserSession(userSession);

        // show app if resource exist
        const resourcesInterval = setInterval(() => {
            if (resourcesDownloaded) {
                app.show()
                clearInterval(resourcesInterval)
            }
        }, 100)
        // ---

        return app
    }
])

// app config
simax.config([
    '$urlRouterProvider',
    '$stateProvider',
    '$locationProvider',
    'i18nProvider',
    'userSessionProvider', (
        $urlRouterProvider: UrlRouterProvider,
        $stateProvider: StateProvider,
        $locationProvider: ng.ILocationProvider,
        i18nProvider,
        userSessionProvider: UserSession
    ) => {
        const locale = userSessionProvider.dataProvider.System.getCurrentLanguage()

        initializeGlobalize(locale)

        i18nProvider.setLanguage(locale)

        if (ConfigHelper.getValue(Enums.SimaxConfigSection.Resources, 'USE_WEBSERVICE_RESOURCES', { defaultValue: false }) === true) {
            DataProvider.getResources(locale)
                .then(((data: any) => {
                    i18nProvider.setResources(JSON.parse(data))
                    resourcesDownloaded = true
                }))
                .fail((error: any) => {
                    LogHelper.error('App', error)
                })
        } else {
            $.ajax(window['config'].API_URL + 'api/app/' + locale + '/resources', {
                method: 'GET',
                contentType: 'application/json; charset=utf-8',
                success: (data) => {
                    i18nProvider.setResources(JSON.parse(data))
                    resourcesDownloaded = true
                },
                error: (error) => {
                    console.log(error)
                }
            })
        }

        $stateProvider.state('home', {
            url: '/',
            controller: ['$scope', '$state', ($scope: ng.IScope, $state: StateService) => {
                $scope.$watchCollection(() => {
                    return $state.get()
                }, (states: StateDeclaration[]) => {
                    var visibleStates = states.filter(state => {
                        if (!state.abstract && state.name != 'login' && state.name != 'logout' && state.name != 'reset' && state.name != 'home') {
                            return true
                        }
                        return false
                    })

                    if (visibleStates.length > 0) {
                        $state.go(visibleStates[0])
                    }
                })
            }],
            template: '<layout><br><br><br><h4 class="text-center">{{$root.i18n("Common", "NoPermissions")}}</h4></layout>',
        })
        $urlRouterProvider.when('', '/')
        $locationProvider.hashPrefix('');
    }])


const initializeGlobalize = (locale: string) => {
    Globalize.loadMessages(deMessages)
    Globalize.loadMessages(enMessages)
    Globalize.loadMessages(esMessages)
    Globalize.loadMessages(frMessages)
    Globalize.loadMessages(itMessages)
    Globalize.loadMessages(ruMessages)
    Globalize.loadMessages({
        pl: {
            'Done': 'Wybierz',
            'Cancel': 'Anuluj',
            'Select': 'Wybierz...',
            'dxList-selectAll': 'Zaznacz wszystko',
            "dxList-pageLoadingText": "Ładowanie...",
            'dxCollectionWidget-noDataText': 'Brak danych',
            'dxDataGrid-validationCancelChanges': 'Anuluj zmiany'
        }
    });

    Globalize.load(supplemental);

    deCldrData.main.de.numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    enCldrData.main.en.numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    enGBCldrData.main['en-GB'].numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    esCldrData.main.es.numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    frCldrData.main.fr.numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    itCldrData.main.it.numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    plCldrData.main.pl.numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    ruCldrData.main.ru.numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";
    srLatnCldrData.main['sr-Latn'].numbers['decimalFormats-numberSystem-latn'].standard = "###0.###";

    Globalize.load(deCldrData)
    Globalize.load(enCldrData)
    Globalize.load(enGBCldrData)
    Globalize.load(esCldrData)
    Globalize.load(frCldrData)
    Globalize.load(itCldrData)
    Globalize.load(plCldrData)
    Globalize.load(ruCldrData)
    Globalize.load(srLatnCldrData)

    Globalize.locale(locale)
}